import { ColumnFilter, Table } from "@tanstack/react-table"
import { CircleX, Search, X } from "lucide-react"
import { DataTableFacetedFilter } from "./FacetsFilter"
import { TableFilter } from "@/types"
import { useSearchParams } from "react-router-dom"


interface DataTableToolbarProps<TData> {
    table: Table<TData>,
    filtersFields: TableFilter[],
    searchField: string,
}

export function DataTableToolbar<TData>({
    table,
    filtersFields,
}: DataTableToolbarProps<TData>) {
    const isFiltered = table.getState().columnFilters.length > 0;
    const [searchParams, setSearchParams] = useSearchParams();

    function handleRemoveFilter(filter: ColumnFilter, filterValue: string) {
        const filterQuery = searchParams.get(filter.id.toLowerCase())?.split(",").filter((item) => item !== filterValue) ?? [];
        if (filterQuery.length > 0) searchParams.set(filter.id.toLowerCase(), filterQuery.toString());
        else searchParams.delete(filter.id.toLowerCase());
        setSearchParams(searchParams);

        table.setColumnFilters((prevFilters) => {
            return prevFilters.map((item) => item.id === item.id ? {
                ...item,
                value: (item.value as string[]).filter(
                    (val) => val !== filterValue
                ),
            } : item).filter((f) => (f.value as string[]).length > 0);
        });
    }

    return (
        <div className="table__filters-container">
            <div className="table__filters-group">
                <div>
                    <div className="table__search">
                        <input
                            placeholder="Search..."
                            onChange={(event) =>
                                table.setGlobalFilter(event.target.value)
                            }
                        />
                        <Search width={18} height={18} />
                    </div>
                </div>
                {filtersFields.map(({ field, options, title }, i) => <div key={i}>
                    {table.getColumn(field) && (
                        <DataTableFacetedFilter
                            column={table.getColumn(field)}
                            title={title}
                            options={options}
                            table={table}
                            filterId={field}
                        />
                    )}
                </div>)}
                {isFiltered && (
                    <button className="filter-button" onClick={() => {
                        table.resetColumnFilters();
                        table.toggleAllPageRowsSelected(false);
                        setSearchParams(new URLSearchParams());
                    }}>
                        Reset
                        <X width={18} height={18} />
                    </button>
                )}

            </div>
            <div>
                {table.getState().columnFilters.length > 0 && (
                    <div className="active-filters">
                        {table.getState().columnFilters.map((filter, i) => (
                            <div className="active-filters__active-filter-list" key={i}>
                                <div className="active-filters__active-filter-container">
                                    {(filter.value as string[]).map((filterValue, i) => (
                                        <button
                                            className="active-filters__active-filter"
                                            onClick={() => handleRemoveFilter(filter, filterValue)}
                                            key={i}
                                        >
                                            <div className="active-filters__active-filter-icon">
                                                <CircleX width={12} height={12} />
                                            </div>
                                            <span className="active-filters__active-filter-text">
                                                {`${filtersFields.find((item) => item.field === filter.id)?.title}: ${filterValue}`}
                                            </span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div >
    )
}